import React from 'react';
import {
    TableRow,
    TableCell,
    Checkbox,
    Chip,
    IconButton,
    Avatar,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const SchoolsTableRow = ({
    school,
    index,
    isArabic,
    isDark,
    page,
    perPage,
    order,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const serial =
        order === 'asc'
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(school?.id);

    return (
        <TableRow
            hover
            role="checkbox"
            aria-checked={isSelected}
            selected={isSelected}
            sx={{
                cursor: 'pointer',
                '&:last-child td, &:last-child th': { border: 0 },
                backgroundColor: isDark
                    ? isOdd ? '#020617' : '#050816'
                    : isOdd ? '#F2F7FF' : '#FFFFFF',
                '&:hover': {
                    backgroundColor: isDark ? '#111827' : '#E3F2FD',
                },
                transition: 'background-color 0.15s ease',
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onChange={(e) => onRowCheckboxClick(e, school?.id)}
                    inputProps={{ 'aria-labelledby': `school-${school?.id}` }}
                />
            </TableCell>
            <TableCell align="center">{serial}</TableCell>
            <TableCell align="center">
                <Avatar
                    alt={school?.name}
                    src={school?.image?.thumb || school?.image?.thumbnail || school?.image?.url || ''}
                    variant="rounded"
                    sx={{ width: 36, height: 36, borderRadius: 1.5 }}
                >
                    {school?.name?.charAt(0)?.toUpperCase()}
                </Avatar>
            </TableCell>
            <TableCell align="center">{school?.code || '-'}</TableCell>
            <TableCell align="center" id={`school-${school?.id}`}>{school?.name}</TableCell>
            <TableCell align="center">{school?.email || '-'}</TableCell>
            <TableCell align="center">{school?.phone || '-'}</TableCell>
            <TableCell align="center">
                <Chip
                    label={
                        school?.is_active
                            ? isArabic ? 'مفعّلة' : 'Active'
                            : isArabic ? 'موقوفة' : 'Inactive'
                    }
                    size="small"
                    color={school?.is_active ? 'success' : 'error'}
                    variant="outlined"
                />
            </TableCell>
            <TableCell align="center">
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, school);
                    }}
                    sx={{ color: isDark ? '#E5E7EB' : '#1F2937' }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default SchoolsTableRow;
